import { render } from "./ZonasPage.vue?vue&type=template&id=5b47970d&scoped=true"
import script from "./ZonasPage.vue?vue&type=script&lang=js"
export * from "./ZonasPage.vue?vue&type=script&lang=js"

import "./ZonasPage.vue?vue&type=style&index=0&id=5b47970d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b47970d"]])

export default __exports__